/// <reference path='../_all.ts' />



module editor {
  'use strict';

  ///Andere Sicht auf Ressourcen, einfacher als Tabelle darstellbar.
  export interface IFilterTree {
    [key: number]: IFilterTreeBranchL1[];
  }
  
  export interface IFilterTreeBranchL1 {
    name : string
    templates : EditorFilter[];
  }



}